<template>
    <div class="row">
        <div class="col-3">
            <div v-if="loading" class="alert alert-info" role="alert">
                <div style="display: inline-block" class="mr-2">
                    <loading :align="'left'" size="1"></loading>
                </div>
                {{ message }}
            </div>
            <div v-else style="height: calc(100vh - 180px); overflow-y: auto">
                <div v-if="fields.length > 0">
                    <form>
                        <div v-for="item in fields" :key="item.index" class="form-group">
                            <label :for="item.index">{{ item.title }}</label>

                            <input
                                v-if="((item.type == '//ly.img.ubq/text') || (item.type == 'variable'))
                                    && (item.line_count < 2) && !item.styled"
                                v-model="item.content"
                                type="text"
                                class="form-control"
                                v-on:change="replaceText(item, 'change')"
                                v-on:keyup="replaceText(item, 'keyup')"
                            >

                            <textarea
                                v-if="(item.type == '//ly.img.ubq/text') && (item.line_count >= 2) && !item.styled"
                                v-model="item.content"
                                class="form-control"
                                v-on:change="replaceText(item, 'change')"
                                v-on:keyup="replaceText(item, 'keyup')"
                                :rows="item.line_count"
                            ></textarea>

                            <div
                                v-if="(item.type == '//ly.img.ubq/text') && item.styled"
                                class="for-inline xxxxform-control xxxxpb-0"
                                style="height: auto; position: relative; z-index: 1"
                            >
                                <editor
                                    v-if="tiny_editor_init"
                                    v-model="item.content"
                                    :init="tiny_editor_init"
                                    @onChange="replaceText(item, 'change')"
                                    @onKeyup="replaceText(item, 'keyup')"
                                    :disabled="false"
                                ></editor>
                            </div>

                            <div v-if="item.type == '//ly.img.ubq/graphic'" class="asset-preview">
                                <div
                                    class="thumbnail"
                                    @click="replaceImage(item.block_id, 'original')"
                                    style="cursor: pointer"
                                >
                                    <img v-if="item.content" class="img-fluid" :src="item.content" alt="item.index">
                                </div>
                                <p class="mt-2 mb-2">Replace with</p>
                                <div class="row">
                                    <div class="col-4">
                                        <div
                                            class="thumbnail small"
                                            @click="replaceImage(item.block_id, 'image1.jpg')"
                                            style="cursor: pointer"
                                        >
                                            <img :src="$root.app.app_url + '/img-ly-demo/image1.jpg'" alt="image1">
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div
                                            class="thumbnail small"
                                            @click="replaceImage(item.block_id, 'image2.jpg')"
                                            style="cursor: pointer"
                                        >
                                            <img :src="$root.app.app_url + '/img-ly-demo/image2.jpg'" alt="image2">
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div
                                            class="thumbnail small"
                                            @click="replaceImage(item.block_id, 'image3.jpg')"
                                            style="cursor: pointer"
                                        >
                                            <img :src="$root.app.app_url + '/img-ly-demo/image3.jpg'" alt="image3">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <hr>
                </div>
                <div v-else class="alert alert-warning" role="alert">
                    There is nothing to edit on this page
                </div>

                <span v-if="exporting !== 'png'">
                    <button
                        :key="'export-png-button'"
                        type="button"
                        class="btn btn-primary btn-block mb-2"
                        @click="exportScene('png')"
                        :disabled="loading || exporting"
                    >
                        Download preview image
                    </button>
                </span>
                <span v-else>
                    <button :key="'exporting-png-button'" type="button" class="btn btn-primary btn-block mb-2">
                        <i class="fal fa-spinner-third fa-spin mr-1"></i>
                        <span style="opacity: 0.5">Download preview image</span>
                    </button>
                </span>

                <span v-if="exporting !== 'pdf'">
                    <button
                        :key="'export-pdf-button'"
                        type="button"
                        class="btn btn-primary btn-block mb-2"
                        @click="exportScene('pdf')"
                        :disabled="loading || exporting"
                    >
                        Download PDF preview
                    </button>
                </span>
                <span v-else>
                    <button :key="'exporting-pdf-button'" type="button" class="btn btn-primary btn-block mb-2">
                        <i class="fal fa-spinner-third fa-spin mr-1"></i>
                        <span style="opacity: 0.5">Download PDF preview</span>
                    </button>
                </span>
            </div>
        </div>
        <div class="col">
            <div id="cesdk-demo-te-container" style="height: calc(100vh - 180px); width: 100%"></div>           
        </div>
    </div>
</template>

<script>
    import CreativeEditorSDK from '@cesdk/cesdk-js';
    import 'tinymce'
    import Editor from '@tinymce/tinymce-vue';
    import 'tinymce/icons/default/icons.min.js';
    import 'tinymce/themes/silver/theme.min.js';
    import 'tinymce/models/dom/model.min.js';
    import 'tinymce/skins/ui/oxide/skin.js';
    import 'tinymce/plugins/code';
    import 'tinymce/plugins/lists';
    import 'tinymce/skins/content/default/content.js';
    export default {
        components: {
            CreativeEditorSDK,
            'editor': Editor
        },
        data () {
            return {
                cesdk: null,
                scene: null,
                loading: true,
                message: 'Loading template',
                fields: [],
                image_fills: {},
                exporting: null,
                tiny_editor_init: null,
                field_styles: null,
                keypress_time: 0,
                event_change: {
                    field: null,
                    content: ''
                },
                style_change: {
                    field: null,
                    content: '',
                    start_line: -1
                }
            }
        },
        async mounted () {
            $('body').removeClass('login-body');

            // Maximise page area.
            $('.header-bar').hide();
            this.$parent.hideMaintenanceNotice();
            $('body').addClass('img-ly-demo');
            
            const cesdkConfig = {
                license: this.$root.app.img_ly_license_key,
                baseURL: 'https://cdn.img.ly/packages/imgly/cesdk-js/1.66.1/assets',
                callbacks: {
                    onUpload: 'local'
                }
            }

            this.cesdk = await CreativeEditorSDK.create('#cesdk-demo-te-container', cesdkConfig);
            await this.cesdk.addDefaultAssetSources();
            await this.cesdk.addDemoAssetSources({ sceneMode: 'Design' });
            
            await this.cesdk.feature.enable('ly.img.navigate.undoRedo', false);
            await this.cesdk.feature.enable('ly.img.preview', false);
            await this.cesdk.feature.enable('ly.img.inspectorBar', false);
            await this.cesdk.feature.enable('ly.img.dock', false);
            await this.cesdk.feature.enable('ly.img.page.resize', false);
            await this.cesdk.feature.enable('ly.img.page.move', false);
            await this.cesdk.feature.enable('ly.img.page.add', false);
            await this.cesdk.feature.enable('ly.img.delete', false);
            //await this.cesdk.feature.enable('ly.img.duplicate', false);
            //await this.cesdk.feature.enable('ly.img.placeholder', false);
            //await this.cesdk.feature.enable('ly.img.replace', false);
            //await this.cesdk.feature.enable('ly.img.text.edit', false);
            //await this.cesdk.feature.enable('ly.img.position', false);
            //await this.cesdk.feature.enable('ly.img.transform.flip', false);

            //await this.cesdk.feature.enable('ly.img.canvasMenu', false);
            await this.cesdk.feature.enable('ly.img.text.advanced', true);

            //await this.cesdk.feature.enable('ly.img.transform.position', false);
            //await this.cesdk.feature.enable('ly.img.transform.size', false);
            //await this.cesdk.feature.enable('ly.img.transform.rotation', false);
            
            await this.cesdk.engine.editor.setGlobalScope('layer/move', 'Deny');
            await this.cesdk.engine.editor.setGlobalScope('layer/rotate', 'Deny');
            await this.cesdk.engine.editor.setGlobalScope('layer/resize', 'Deny');
            await this.cesdk.engine.editor.setGlobalScope('editor/select', 'Deny');

            await this.loadScene();
        },
        beforeUnmount() {
            if (this.cesdk) {
                this.cesdk.dispose();
                this.cesdk = null;
            }
        },
        watch: {
            //
        },
        methods: {
            loadScene: function () {
                this.fields = [];
                this.loading = true;
                var vm = this;
                this.cesdk.engine.scene.loadFromArchiveURL(
                    this.$root.app.app_url + '/img-ly-demo/archive.zip'
                )
                .then(response => {
                    vm.scene = response;
                    vm.getPlaceholders();
                })
                .catch(function (error) {
                    console.log(error);
                    vm.loading = false;
                });
            },
            getPlaceholders: function () {
                this.message = 'Detecting editable fields';
                const placeholders = this.cesdk.engine.block.findAllPlaceholders();
                const blocks = this.cesdk.engine.block.findAll();
                
                blocks.forEach((item) => {
                    let hasVariable = this.cesdk.engine.block.referencesAnyVariables(item);
                    if (hasVariable || (placeholders.indexOf(item) > -1)) {
                        let title = this.cesdk.engine.block.getName(item);
                        let type = this.cesdk.engine.block.getType(item);
                        let typefaces = null;
                        let content = null;
                        let styled = null;
                        let opacity = null;
                        let duplicate = null;
                        let lineCount = null;
                        
                        if (type == '//ly.img.ubq/text') {
                            typefaces = this.cesdk.engine.block.getTypefaces(item);
                            lineCount = this.cesdk.engine.block.getTextVisibleLineCount(item);
                            content = [];
                            for (let line = 0; line < lineCount; line++) {
                                content.push(this.cesdk.engine.block.getTextVisibleLineContent(item, line));
                            }
                            content = content.join(' ');

                            if (placeholders.indexOf(item) > -1) {
                                let fontWeights = this.cesdk.engine.block.getTextFontWeights(item);
                                let fontStyles = this.cesdk.engine.block.getTextFontStyles(item);
                                styled = ((fontWeights.length > 1) || (fontStyles.length > 1));

                                if (styled) {
                                    opacity = 1;
                                    if (this.cesdk.engine.block.supportsOpacity(item)) {
                                        opacity = this.cesdk.engine.block.getOpacity(item);
                                    }
                                    duplicate = this.cesdk.engine.block.duplicate(item);
                                    this.cesdk.engine.block.setOpacity(duplicate, 0);

                                    // Convert to HTML.
                                    let length = content.length;
                                    let html = '';
                                    let isRangeBold = false;
                                    let isRangeItalic = false;
                                    let lb = 0;
                                    for (let c = 0; c < length; c++) {
                                        let char = content.substring(c, c + 1);
                                        let charCode = content.charCodeAt(c);
                                        if (charCode == 8232) {
                                            // Line break.
                                            html += '<br>';
                                            lb++;
                                        } else {
                                            fontWeights = this.cesdk.engine.block
                                                .getTextFontWeights(item, c - lb, c - lb + 1);
                                            let isBold = (fontWeights[0] == 'bold');
                                            if (isBold != isRangeBold) {
                                                html += (isBold ? '<strong>' : '</strong>');
                                                isRangeBold = isBold;
                                            }

                                            fontStyles = this.cesdk.engine.block
                                                .getTextFontStyles(item, c - lb, c - lb + 1);
                                            let isItalic = (fontStyles[0] == 'italic');
                                            if (isItalic != isRangeItalic) {
                                                html += (isItalic ? '<em>' : '</em>');
                                                isRangeItalic = isItalic;
                                            }

                                            html += char;
                                        }
                                    }
                                    if (isRangeBold) {
                                        html += '</strong>';
                                    }
                                    if (isRangeItalic) {
                                        html += '</em>';
                                    }
                                    content = '<p>' + html + '</p>';
                                }
                            }

                            if (hasVariable) {
                                // Add variables.
                                const parts = content.split('{{');
                                parts.forEach((part) => {
                                    let index = part.indexOf('}}');
                                    if (index > 0) {
                                        let variable = part.substring(0, index);
                                        this.fields.unshift({
                                            index: this.fields.length,
                                            block_id: variable.toLowerCase(),
                                            title: this.$root.ucfirst(variable.replace(/_/g, ' ').toLowerCase()),
                                            type: 'variable',
                                            //content: '{{' + variable + '}}',
                                            content: variable,
                                            styled: false,
                                            line_count: 1
                                        });

                                        this.replaceText(this.fields[0])
                                    }
                                });
                            }
                        }
                        if (placeholders.indexOf(item) > -1) {
                            if (type == '//ly.img.ubq/graphic') {
                                this.exportImage(item, item);
                            }

                            this.fields.unshift({
                                index: this.fields.length,
                                block_id: item,
                                title: title,
                                type: type,
                                typefaces: typefaces,
                                content: content,
                                styled: styled,
                                opacity: opacity,
                                duplicate_block_id: duplicate,
                                line_count: lineCount
                            });

                            if (styled && !this.tiny_editor_init) {
                                this.initTinyMce();
                            }
                        }
                    }
                });

                var vm = this;
                setTimeout(function () { vm.loading = false; }, 1000);
            },
            exportImage: function (imageFill, fieldBlock) {
                var vm = this;
                this.cesdk.engine.block.export(
                    imageFill,
                    {
                        mimeType: 'image/png',
                        pngCompressionLevel: 7
                    }
                )
                .then(response => {
                    vm.fields.forEach((item) => {
                        if (item.block_id == fieldBlock) {
                            item.content = window.URL.createObjectURL(response);
                        }
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            stripTags: function (html, allowedTags = '') {
                allowedTags = allowedTags.trim();
                
                if (allowedTags) {
                    allowedTags = allowedTags.split(/\s+/).map(function(tag){ return "/?" + tag });
                    allowedTags = "(?!" + allowedTags.join("|") + ")";
                }

                return html.replace(new RegExp("(<" + allowedTags + ".*?>)", "gi"), "");
            },
            decodeEntity: function (str) {
                var element = document.createElement('div');
                element.innerHTML = str;
                str = element.textContent;
                element.textContent = '';

                return str;
            },
            replaceText: function (field, event = null, delay = true) {
                var vm = this;
                var vmField = field;
                var vmEvent = event
                if (delay && (field.content.indexOf('<ul>') > -1)) {
                    setTimeout(function () {
                        vm.replaceText(vmField, vmEvent, false);
                    }, (20 + Math.round(Math.random() * 10)));

                    return null;
                }

                //console.log(field.title, event, field.content.toString(), this.event_change.content.toString());

                if ((field.content == this.event_change.content) && (field.title == this.event_change.field)) {
                    
                    //console.log('replace text abort, content unchanged');

                    return null;
                }
                this.event_change = {
                    field: field.title,
                    content: field.content
                };

                //console.log('replace text for field', field.title, 'time passed', eventTimePassed);

                let content = field.content;
                let boldRanges = [];
                let italicRanges = [];
                let hasBulletList = false;
                let length = 0;
                let text = '';
                if (field.styled) {
                    // Convert HTML to text.
                    content = this.stripTags(content, 'p br strong em ul li');
                    content = content.replace(/<br>/g, '\n'); // Soft return/line break.
                    content = content.replace(/<\/p>/g, '</p>\n'); // Hard return/new paragraph.
                    length = content.length;
                    text = '';
                    let boldRange = null;
                    let italicRange = null;
                    for (let c = 0; c < length; c++) {
                        let char = content.charAt(c);
                        let htmlTag = false;
                        if (content.substring(c, c + 3) == '<p>') {
                            htmlTag = true;
                            c += 2;
                        } else if (content.substring(c, c + 4) == '</p>') {
                            htmlTag = true;
                            c += 3;
                        } else if (content.substring(c, c + 8) == '<strong>') {
                            htmlTag = true;
                            boldRange = {
                                from: text.length
                            }
                            c += 7;
                        } else if (content.substring(c, c + 9) == '</strong>') {
                            htmlTag = true;
                            boldRange.to = text.length;
                            boldRanges.push(boldRange);
                            boldRange = null;
                            c += 8;
                        } else if (content.substring(c, c + 4) == '<em>') {
                            htmlTag = true;
                            italicRange = {
                                from: text.length
                            }
                            c += 3;
                        } else if (content.substring(c, c + 5) == '</em>') {
                            htmlTag = true;
                            italicRange.to = text.length;
                            italicRanges.push(italicRange);
                            italicRange = null;
                            c += 4;
                        } else if (content.substring(c, c + 5) == '<ul>\n') {
                            htmlTag = true;
                            c += 4;
                        } else if (content.substring(c, c + 5) == '</ul>') {
                            htmlTag = true;
                            c += 4;
                        } else if (content.substring(c, c + 4) == '<li>') {
                            hasBulletList = true;
                            char = this.decodeEntity('&bull;') + '  ';
                            c += 3;
                        } else if (content.substring(c, c + 31) == '<li style="font-weight: bold;">') {
                            hasBulletList = true;
                            char = this.decodeEntity('&bull;') + '  ';
                            c += 30;
                        } else if (content.substring(c, c + 32) == '<li style="font-style: italic;">') {
                            hasBulletList = true;
                            char = this.decodeEntity('&bull;') + '  ';
                            c += 31;
                        } else if (
                            (content.substring(c, c + 51) == '<li style="font-weight: bold; font-style: italic;">')
                            || (content.substring(c, c + 51) == '<li style="font-style: italic; font-weight: bold;">')
                        ) {
                            hasBulletList = true;
                            char = this.decodeEntity('&bull;') + '  ';
                            c += 50;
                        } else if (content.substring(c, c + 5) == '</li>') {
                            htmlTag = true;
                            c += 4;
                        } else if (char == '&') {
                            let str = content.substring(c);
                            let index = str.indexOf(';');
                            if ((index > -1) && (index < 10)) {
                                char = this.decodeEntity(str.substring(0, index + 1));
                                c += index;
                            }
                        }
                        if (!htmlTag) {
                            text += char;
                        }
                    }
                    content = text;
                }

                // Smart quotes.
                if ((content.indexOf('"') > -1) || (content.indexOf("'") > -1)) {
                    length = content.length;
                    text = '';
                    for (let c = 0; c < length; c++) {
                        let char = content.charAt(c);
                        if (
                            (char == '"')
                            && (content.charCodeAt(c + 1) != 32)
                            && ((c == 0) || (content.charCodeAt(c - 1) == 32) || (content.charCodeAt(c - 1) == 10))
                        ) {
                            text += this.decodeEntity('&ldquo;');
                        } else if (
                            (char == '"')
                            /*&& (c > 0)
                            && (content.charCodeAt(c - 1) != 32)
                            && (
                                (c == (length - 1))
                                || (content.charCodeAt(c + 1) == 32)
                                || (content.charCodeAt(c + 1) == 10)
                                || (content.charAt(c + 1) == '.')
                            )*/
                        ) {
                            text += this.decodeEntity('&rdquo;');
                        } else if (
                            (char == "'")
                            && (content.charCodeAt(c + 1) != 32)
                            && ((c == 0) || (content.charCodeAt(c - 1) == 32) || (content.charCodeAt(c - 1) == 10))
                        ) {
                            text += this.decodeEntity('&lsquo;');
                        } else if (
                            (char == "'")
                            /*&& (c > 0)
                            && (content.charCodeAt(c - 1) != 32)
                            && (
                                (c == (length - 1))
                                || (content.charCodeAt(c + 1) == 32)
                                || (content.charCodeAt(c + 1) == 10)
                                || (content.charAt(c + 1) == '.')
                            )*/
                        ) {
                            text += this.decodeEntity('&rsquo;');
                        } else {
                            text += char;
                        }
                    }
                    content = content = this.stripTags(text);
                }

                if (field.type == 'variable') {
                    this.cesdk.engine.variable.setString(field.block_id, content);
                } else {
                    const editBlockId = (field.duplicate_block_id && hasBulletList) ? field.duplicate_block_id : field.block_id;
                    this.cesdk.engine.block.replaceText(editBlockId, content);
                }

                if (field.styled) {
                    this.field_styles = {
                        field: field,
                        has_bullet_list: hasBulletList,
                        bold_ranges: boldRanges,
                        italic_ranges: italicRanges,
                        start_line: 0
                    }
                    if (!hasBulletList) {
                        this.keypress_time = 0;
                        this.styleFieldText();

                        return null;
                    }
                    this.styleFieldText(true);
                }
            },
            styleFieldText: function (delay = false) {
                var vm = this;
                if (delay) {
                    this.keypress_time = new Date();
                    setTimeout(function () {
                        vm.styleFieldText();
                    }, (490 + Math.round(Math.random() * 10)));

                    return null;
                }
                const time = new Date();
                if ((time - this.keypress_time) < 400) {
                    
                    //console.log(this.field_styles.field.title, 'new change, abort');

                    return null;
                }

                const field = this.field_styles.field;
                const startLine = this.field_styles.start_line;

                if (
                    (field.title == this.style_change.field)
                    && (field.content == this.style_change.content)
                    && (startLine == this.style_change.start_line)
                ) {
                    //console.log('style text abort, content unchanged');

                    return null;
                }
                this.style_change = {
                    field: field.title,
                    content: field.content,
                    start_line: startLine
                };

                const hasBulletList = this.field_styles.has_bullet_list;
                const boldRanges = this.field_styles.bold_ranges;
                const italicRanges = this.field_styles.italic_ranges;
                const bulletSpaces = '    ';
                const indentSpaces = '       ';
                const editBlockId = (field.duplicate_block_id && hasBulletList)
                    ? field.duplicate_block_id
                    : field.block_id;
                
                //console.log('style', this.field_styles.field.title, 'line', this.field_styles.start_line, this.field_styles.field.content, editBlockId);

                let typefaces = [];
                try {
                    typefaces = this.cesdk.engine.block.getTypefaces(editBlockId);
                } catch (error) {
                    //
                }
                if (typefaces.length == 0) {
                    this.cesdk.engine.block.setTypeface(editBlockId, field.typefaces[0], -1, -1);
                }

                if (hasBulletList) {
                    // Indent bullet points.
                    let lineCount = this.cesdk.engine.block.getTextVisibleLineCount(editBlockId);
                    let line = 0;
                    let callAgain = false;
                    let shiftRanges = null;
                    let previousLineText = '';
                    let c = 0;
                    while ((line < lineCount) && !callAgain) {
                        let text = this.cesdk.engine.block.getTextVisibleLineContent(editBlockId, line);
                        
                        //console.log('line', line, '|' + text + '|', text.charCodeAt(0));

                        if ((line >= startLine) && (text.length > 0)) {
                            let firstCharCode = (text.length > 0) ? text.charCodeAt(0) : -1;
                            let isLineEmpty = ((firstCharCode == 10) && (text.length == 1));
                            let isPreviousLineEmpty = (
                                (previousLineText.charCodeAt(0) == 10) && (previousLineText.length == 1)
                            );
                            if (firstCharCode == 8226) {
                                this.cesdk.engine.block.replaceText(editBlockId, bulletSpaces, c, c);
                                boldRanges.push({
                                    from: c,
                                    to: c + 1
                                });
                                callAgain = true;
                                shiftRanges = {
                                    from: c,
                                    by: bulletSpaces.length
                                };
                                this.field_styles.start_line = line + 1;
                            }
                            if (!callAgain && (firstCharCode > -1) && !isLineEmpty && !isPreviousLineEmpty) {
                                let isInBulletPoint = (previousLineText.length > 0)
                                    ? (
                                        (previousLineText.charCodeAt(bulletSpaces.length) == 8226)
                                        || (previousLineText.indexOf(indentSpaces) == 0)
                                    )
                                    : false;
                                if (isInBulletPoint && (firstCharCode != 8226)) {

                                    //console.log('add indent from pos', c);

                                    let previousLineEndsWithLineBreak = (
                                        (previousLineText.length > 0)
                                        && (previousLineText.charCodeAt(previousLineText.length - 1) == 10)
                                    );

                                    this.cesdk.engine.block.replaceText(
                                        editBlockId,
                                        (previousLineEndsWithLineBreak ? ' ' : '\n') + indentSpaces,
                                        c,
                                        c
                                    );
                                    callAgain = true;
                                    shiftRanges = {
                                        from: c,
                                        by: 1 + indentSpaces.length
                                    };
                                    /*if (!previousLineEndsWithLineBreak) {
                                        shiftRanges.by += 1;
                                    }*/
                                    this.field_styles.start_line = line + 1;
                                }
                            }
                        }

                        previousLineText = text;
                        c += text.length;
                        line++;
                    }
                    if (callAgain) {
                        //console.log('call again');

                        if (shiftRanges !== null) {
                            boldRanges.forEach((item) => {
                                if (item.from >= shiftRanges.from) {
                                    item.from += shiftRanges.by;
                                    item.to += shiftRanges.by;
                                } else if (item.to >= shiftRanges.from) {
                                    let to = item.to;
                                    item.to = shiftRanges.from;
                                    boldRanges.push({
                                        from: shiftRanges.from + shiftRanges.by,
                                        to: to + shiftRanges.by
                                    });
                                }
                            });
                            this.field_styles.bold_ranges = boldRanges;

                            italicRanges.forEach((item) => {
                                if (item.from >= shiftRanges.from) {
                                    item.from += shiftRanges.by;
                                    item.to += shiftRanges.by;
                                } else if (item.to >= shiftRanges.from) {
                                    let to = item.to;
                                    item.to = shiftRanges.from;
                                    italicRanges.push({
                                        from: shiftRanges.from + shiftRanges.by,
                                        to: to + shiftRanges.by
                                    });
                                }
                            });
                            this.field_styles.italic_ranges = italicRanges;
                        }

                        setTimeout(function () {
                            //vm.keypress_time = 0;
                            vm.styleFieldText();
                        }, 20);

                        return null;
                    }
                }

                this.addStyles(editBlockId, boldRanges, italicRanges);

                if (editBlockId == field.duplicate_block_id) {
                    this.cesdk.engine.block.setOpacity(field.block_id, 0);
                    this.cesdk.engine.block.setOpacity(field.duplicate_block_id, field.opacity);
                    let itemIndex = -1;
                    this.fields.forEach((item, index) => {
                        if (item.block_id == field.block_id) {
                            itemIndex = index;
                        }
                    });
                    if (itemIndex > -1) {
                        const blockId = field.block_id;
                        const duplicateBlockId = field.duplicate_block_id;
                        this.fields[itemIndex].duplicate_block_id = null;
                        this.fields[itemIndex].block_id = duplicateBlockId;
                        this.fields[itemIndex].duplicate_block_id = blockId;
                    }
                }
            },
            addStyles: function (blockId, boldRanges, italicRanges) {
                this.cesdk.engine.block.setTextFontWeight(blockId, 'normal', -1, -1);
                boldRanges.forEach((item) => {
                    this.cesdk.engine.block.setTextFontWeight(blockId, 'bold', item.from, item.to);
                });
                this.cesdk.engine.block.setTextFontStyle(blockId, 'normal', -1, -1);
                italicRanges.forEach((item) => {
                    this.cesdk.engine.block.setTextFontStyle(blockId, 'italic', item.from, item.to);
                });
            },
            replaceImage: function (blockId, image) {
                if (!('original' in this.image_fills)) {
                    this.image_fills.original = this.cesdk.engine.block.getFill(blockId);
                }

                if (!(image in this.image_fills)) {
                    const imageUri = this.$root.app.app_url + '/img-ly-demo/' + image;
                    const imageFill = this.cesdk.engine.block.createFill('image');
                    this.image_fills[image] = imageFill;
                    this.cesdk.engine.block.setFill(blockId, imageFill);
                    this.cesdk.engine.block.setString(imageFill, 'fill/image/imageFileURI', imageUri);

                    return null;
                }

                this.cesdk.engine.block.setFill(blockId, this.image_fills[image]);
            },
            exportScene: function (type) {
                this.exporting = type;
                var vm = this;
                const options = (type == 'png')
                    ? {
                        mimeType: 'image/png',
                        pngCompressionLevel: 7
                    }
                    : {
                        mimeType: 'application/pdf',
                        exportPdfWithUnderlayer: true,
                        underlayerSpotColorName: 'RDG_WHITE',
                        underlayerOffset: -2.0
                    }
                this.cesdk.engine.block.export(
                    this.scene,
                    options
                )
                .then(response => {
                    const element = document.createElement('a');
                    element.setAttribute('href', window.URL.createObjectURL(response));
                    element.setAttribute('download', 'preview.' + type);
                    element.style.display = 'none';
                    element.click();
                    element.remove();
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() =>
                    setTimeout(function () { vm.exporting = null; }, 1000)
                );
            },
            initTinyMce: function () {
                let plugins = ['lists'];
                let toolbar = 'bold italic bullist';
                let tinyEditorInit = {
                    license_key: 'gpl',
                    height: 200,
                    menubar: false,
                    elementpath: false,
                    branding: false,
                    resize: true,
                    plugins: plugins,
                    toolbar: toolbar,
                    //inline: true,
                    browser_spellcheck: true,
                    content_style: this.$root.tiny_mce_content_styles
                };
                this.tiny_editor_init = tinyEditorInit;

                // Prevent Bootstrap dialog from blocking focusin
                $(document).on('focusin', function(e) {
                    if (
                        $(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root")
                            .length
                    ) {
                        e.stopImmediatePropagation();
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .asset-preview .thumbnail {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
        height: auto;
        text-align: center;
    }

    .asset-preview .thumbnail img {
        max-height: 198px;
        position: static;
        margin: 0;
    }

    .asset-preview .thumbnail.small img {
        max-height: 98px;
    }
</style>
